// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/api_keys.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/api_keys.proto.
 */
export const file_cortado_v1_api_keys: GenFile = /*@__PURE__*/
  fileDesc("Chljb3J0YWRvL3YxL2FwaV9rZXlzLnByb3RvEgpjb3J0YWRvLnYxIscCCgZBcGlLZXkSCgoCaWQYASABKAkSFwoPb3JnYW5pemF0aW9uX2lkGAIgASgJEgwKBG5hbWUYAyABKAkSEgoKa2V5X3ByZWZpeBgEIAEoCRIuCgpjcmVhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpjcmVhdGVkX2J5GAYgASgJEjUKDGxhc3RfdXNlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBARIzCgpyZXZva2VkX2F0GAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgBiAEBEhcKCnJldm9rZWRfYnkYCSABKAlIAogBAUIPCg1fbGFzdF91c2VkX2F0Qg0KC19yZXZva2VkX2F0Qg0KC19yZXZva2VkX2J5QiZaJGh1Yi1iYWNrZW5kL2dlbi9jb3J0YWRvL3YxO2NvcnRhZG92MWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * ApiKey is a tenant-issued credential for the external HTTP API (/api/v1/ext).
 * The secret itself is never stored or returned after creation; only a display
 * prefix is exposed.
 *
 * @generated from message cortado.v1.ApiKey
 */
export type ApiKey = Message<"cortado.v1.ApiKey"> & {
  /**
   * Unique identifier for the API key
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the key belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Human-readable label chosen by the tenant
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * First characters of the secret (e.g. "cort_a1b2c3d") for display only
   *
   * @generated from field: string key_prefix = 4;
   */
  keyPrefix: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * User ID that created the key
   *
   * @generated from field: string created_by = 6;
   */
  createdBy: string;

  /**
   * Last time the key authenticated a request (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp last_used_at = 7;
   */
  lastUsedAt?: Timestamp;

  /**
   * Time the key was revoked (optional; absent while active)
   *
   * @generated from field: optional google.protobuf.Timestamp revoked_at = 8;
   */
  revokedAt?: Timestamp;

  /**
   * User ID that revoked the key (optional)
   *
   * @generated from field: optional string revoked_by = 9;
   */
  revokedBy?: string;
};

/**
 * Describes the message cortado.v1.ApiKey.
 * Use `create(ApiKeySchema)` to create a new message.
 */
export const ApiKeySchema: GenMessage<ApiKey> = /*@__PURE__*/
  messageDesc(file_cortado_v1_api_keys, 0);

